import options from './thing-chart.component';

export default {
    selector: 'dtThingChart',
    options
};



// WEBPACK FOOTER //
// ./app/components/sensors-and-connectors/components/thing-chart/index.js